const officialLanguageOptions = [
  { value: 'Afrikaans', label: 'Afrikaans' },
  { value: 'Afar', label: 'Afar' },
  { value: 'Amharic', label: 'Amharic' },
  { value: 'English', label: 'English' },
  { value: 'French', label: 'French' },
  { value: 'Arabic', label: 'Arabic' },
  { value: 'Bambara', label: 'Bambara' },
  { value: 'Berber (Amazigh)', label: 'Berber (Amazigh)' },
  { value: 'Bissa', label: 'Bissa' },
  { value: 'Chichewa', label: 'Chichewa' },
  { value: 'Comorian', label: 'Comorian' },
  { value: 'Dyula', label: 'Dyula' },
  { value: 'Fula', label: 'Fula' },
  { value: 'Hassaniya Arabic', label: 'Hassaniya Arabic' },
  { value: 'Hausa', label: 'Hausa' },
  { value: 'Kikongo', label: 'Kikongo' },
  { value: 'Kinyarwanda', label: 'Kinyarwanda' },
  { value: 'Kirundi', label: 'Kirundi' },
  { value: 'Lingala', label: 'Lingala' },
  { value: 'Malagasy', label: 'Malagasy' },
  { value: 'Maninke', label: 'Maninke' },
  { value: 'Mooré', label: 'Mooré' },
  { value: 'Ndebele', label: 'Ndebele' },
  { value: 'Oromo', label: 'Oromo' },
  { value: 'Portuguese', label: 'Portuguese' },
  { value: 'Sango', label: 'Sango' },
  { value: 'Seychellois Creole', label: 'Seychellois Creole' },
  { value: 'Shona', label: 'Shona' },
  { value: 'Somali', label: 'Somali' },
  { value: 'Songhay', label: 'Songhay' },
  { value: 'Soninke', label: 'Soninke' },
  { value: 'Spanish', label: 'Spanish' },
  { value: 'Swahili', label: 'Swahili' },
  { value: 'Swati', label: 'Swati' },
  { value: 'Tamasheq', label: 'Tamasheq' },
  { value: 'Tigrinya', label: 'Tigrinya' },
  { value: 'Tsonga', label: 'Tsonga' },
  { value: 'Tswana', label: 'Tswana' },
  { value: 'Tshivenda', label: 'Tshivenda' },
  { value: 'Tshiluba', label: 'Tshiluba' },
  { value: 'Umbundu', label: 'Umbundu' },
  { value: 'Xhosa', label: 'Xhosa' },
  { value: 'Zulu', label: 'Zulu' },
];

export default officialLanguageOptions;